import React, {Component} from 'react'
import PropTypes from 'prop-types'
import './MovieControls.scss'

import PlayPauseButton from './PlayPauseButton'
import Scrubbler from './Scrubbler'
import TimeIndicator from './TimeIndicator'

export default class MovieControls extends Component {

  static propTypes = {
    corePlayerConnection: PropTypes.object.isRequired,
    currentTime: PropTypes.number.isRequired,
    isPlaying: PropTypes.bool.isRequired,
    isEnd: PropTypes.bool.isRequired
  }

  state = {
    corePlayerCurrentTime: 0
  }

  componentDidUpdate(preProps, state){
    if (preProps.currentTime !== this.props.currentTime)
    {
      this.setState( {corePlayerCurrentTime: this.props.currentTime})
    }
  }

  updateTotalTime(currentTime){
    this.setState({corePlayerCurrentTime: currentTime})
  }

  updateIsPlay(value){
    this.isPlay = value
  }


  restart = () => {
    const {corePlayerConnection} = this.props
    corePlayerConnection.changeAbsoluteTime(0)
    corePlayerConnection.play()
  }

  setTime = (newTime) => {
    this.props.corePlayerConnection.changeAbsoluteTime(newTime)
    this.updateTotalTime(newTime)
  }

  render() {
    const {isPlaying, isEnd, play, pause, totalDuration, disabled} = this.props
    const {corePlayerCurrentTime} = this.state
    const {restart, setTime} = this
    const calculatedCurrentTime = corePlayerCurrentTime

    return (
      <div styleName="movie-controls">
        <PlayPauseButton
          isPlaying={isPlaying}
          isEnd={isEnd}
          onPlay={play}
          onPause={pause}
          onRestart={restart}
          disabled={disabled}
        />
        <Scrubbler
          currentTime={calculatedCurrentTime}
          totalTime={totalDuration}
          onChange={setTime}
          disabled={disabled}
        />
        <TimeIndicator currentTime={calculatedCurrentTime} totalTime={totalDuration}/>
      </div>
    )
  }
}
